import { t } from '@lingui/core/macro';
function fontItems() {
    return {
        icon: false,
        label: t({ comment: 'Pleditor - Fonts toolbar button label', message: 'Fonts' }),
        items: ['fontSize', 'fontColor', 'fontBackgroundColor'],
    };
}
function commentItems() {
    return {
        icon: false,
        label: t({ comment: 'Pleditor - Comments toolbar button label', message: 'Comments' }),
        items: ['inlineComment', '|', 'commentsArchive', '|', 'toggleComments'],
    };
}
export function documentFormattingToolbarItems() {
    const items = [
        'undo',
        'redo',
        '|',
        'heading',
        fontItems(),
        '|',
        'bold',
        'italic',
        'strikethrough',
        'underline',
        'bulletedList',
        'numberedList',
        'multiLevelList',
        'alignment',
        '|',
        'outdent',
        'indent',
        '|',
        'link',
        'insertImage',
        '|',
        'insertTable',
        '|',
        'pageBreak',
    ];
    return items;
}
export function documentCollaborativeEditingToolbarItems() {
    return [commentItems(), '|', 'revisionHistory', '|', 'editMode'];
}
export function documentRestrictedToolbarItems() {
    const items = [
        'undo',
        'redo',
        '|',
        'bold',
        'italic',
        'strikethrough',
        'underline',
        '|',
        'alignment',
        '|',
        'fontColor',
        'fontBackgroundColor',
        '<->',
        ...commentItems().items,
    ];
    return items;
}
